import Vue from 'vue'
import App from './App.vue'

// Use for Menu trigger
export const menuBus = new Vue();

new Vue({
  el: '#app',
  render: h => h(App)
})





// WEBPACK FOOTER //
// ./src/main.js